<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="grid-column ai-c jc-s gap-10">
        <button
          type="button"
          class="ac-close-button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div class="ac-header">
          Notes
        </div>
      </div>
      <button
        type="button"
        class="sac__button-med2 bg-primary"
        @click="handleAddNote"
      >
        <span>+ Add a note</span>
      </button>
    </div>
    <div v-if="loadingNotes" class="loading-container">
      <img src="@shared/assets/img/general/loading.svg">
    </div>
    <div v-else-if="customerNoteList.length" class="ac-body-container">
      <div
        v-for="(log, idx) in customerNoteList"
        :key="idx"
      >
        <div>
          <div class="grid-column ai-s jc-b gap-16">
            <div class="sac__font-12 semi-bold">
              {{ log.userName }} - {{ formatNoteDate(log.noteDate) }}
              at {{ formatTime(log.noteDate) }}
            </div>
            <div class="grid-column ai-c gap-16">
              <button
                v-if="isEditable(log.userName, log.noteDate)"
                @click="handleNoteView(log, true)"
              >
                <img src="@shared/assets/img/service/primary-edit.svg" alt="edit" class="img-size-16" />
              </button>
              <button
                v-if="isSmacAdmin"
                @click="deleteNote(log)"
              >
                <img src="@shared/assets/img/service/primary-delete.svg" alt="delete" class="img-size-16" />
              </button>
            </div>
          </div>
          <div class="note-container">
            {{ log.note }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="sac__font-14 semi-bold center margin-top-16">
      No notes found..
    </div>
  </div>
</template>

<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import formatterMixin from '@shared/mixins/formatterMixin';

export default {
  name: 'ViewAllNotes',
  mixins: [serviceMixin, formatterMixin],
  mounted() {
    if (this.serviceInfo.customerId) {
      this.getCustomerNotes();
    }
  },
  methods: {
    getCustomerNotes() {
      this.$store.dispatch('getCustomerNotes', this.serviceInfo.customerId);
    },
  },
};
</script>

<style lang="scss" scoped>
.note-container {
  padding: 12px;
  margin-top: 8px;
  margin-bottom: 16px;
  background-color: $N5;
  border-radius: 6px;
  font-size: 14px;
  color: $N90;
}
</style>
